import { render, staticRenderFns } from "./BindAddress.vue?vue&type=template&id=b36ff2de&scoped=true"
import script from "./BindAddress.vue?vue&type=script&lang=js"
export * from "./BindAddress.vue?vue&type=script&lang=js"
import style0 from "./BindAddress.vue?vue&type=style&index=0&id=b36ff2de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b36ff2de",
  null
  
)

export default component.exports